// frontend/src/components/Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const wrap = {
  maxWidth: 1120,
  margin: "0 auto",
  padding: "12px 16px 32px", // Reduced top padding for content closer to navbar
  width: "100%",
};

export default function Layout() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        color: "#111827",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Navbar />
      <main style={{ ...wrap, flex: 1 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}